  import { Button, Card, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { APIService } from "../../common/apiService";
import { getHomePageDataUrl, getMasterDataUrl } from "../../common/apiUrl";
import PageTitle from "../../layout/components/content/page-title";
import AnimatedLinechart from "../chartdata/animatedLinechart";
import CustomLineChart from "../chartdata/customLineChart";
import LineChart from "../chartdata/LineChart";
import Downloadreport from "../customComponent/downloadReport/downloadreport";
const { Option } = Select;

export default function Home() {
  const [loading, setLoading] = useState(false);
  const [masterdata, setMasterData] = useState({});
  const [data, setData] = useState([]);
  const GetHomePageData = () => {
    const model = {
      "fromdate": "2022-06-01",
      "todate": "2022-06-03"
    }
    APIService.post(getHomePageDataUrl)
      .then(res => {
        if (!res.data.isError) {
          if (res.data.data) {
            console.log('Home Page Data 123', res.data.data)
            setData(res.data.data);
          }
        }
        else {
          Swal.fire(res.data.message, '', 'error');
        }
      }).catch(error => {
        // setdataLoad(false);
        console.log("error", error)
      })
  }
  const GetMasterData = () => {
    APIService.get(getMasterDataUrl)
      .then(res => {
        if (!res.data.isError) {
          if (res.data.data) {
           // console.log('data 123', res.data.data)
            setMasterData(res.data.data);
          }
        }
        else {
          Swal.fire(res.data.message, '', 'error');
        }
      }).catch(error => {
        // setdataLoad(false);
        console.log("error", error)
      })
  }
  useEffect(() => {
    GetMasterData();
    GetHomePageData();
  }, []);
  return (<>
    <Row gutter={[32, 32]}>

      <PageTitle
        pageTitle="Home"
      />
    </Row>
    <Row gutter={[16, 16]}>
    {data.avgreading != undefined &&
        data.avgreading.map(o => (
          <Col span={10} md={4}>
            <div id="customcard" >
              <label className="tLable">{o.title}</label><p>
                <span><label className="vLable" >{o.avgreading} </label >mg/dl</span></p>
            </div>
          </Col>
        ))
      }
    </Row>
    <Row gutter={[32, 32]}>
      {/* <CustomLineChart style={{}}/> */}
      <AnimatedLinechart/>
      <Downloadreport/>
    </Row>
  </>
  );
}
